import {
  InsightsProduct,
  SharedInsightsProduct,
} from "../graphql/fragments/product";

export const isInsightsProduct = (
  product: InsightsProduct | SharedInsightsProduct
): product is InsightsProduct => {
  return product.proprietaryDataset === "VENN";
};

const capitalize = (str: string): string => {
  if (!str) {
    return "";
  }
  return str[0].toUpperCase() + str.slice(1);
};

const capitalizeAllWords = (str: string): string => {
  if (!str) {
    return "";
  }
  return str.toLowerCase().trim().split(/\s+/).map(capitalize).join(" ");
};

export { capitalizeAllWords };
